export const TAB_OPTIONS = [
  {
    name: 'CreateKybKyc',
    value: 'vaultCreateKybKycSubmit',
    text: 'Create KybKyc',
    selected: true,
  },
  {
    name: 'OrgConfirmation',
    value: 'vaultOrgConfirmationSubmit',
    text: 'Org Confirmation',
    selected: false,
  },
  {
    name: 'DefaultPaymentMethodSet',
    value: 'vaultStripeConnectAccountPayoutFrequencySet',
    text: 'Default Payment Method',
    selected: false,
  },
  {
    name: 'PayoutFrequencySet',
    value: 'vaultStripeConnectAccountPayoutFrequencySet',
    text: 'Set Payout Frequency',
    selected: false,
  },
];
